import React from 'react';
import { useButton } from 'components/button/logic';
import { StyledButton, Label, Content, Loader } from './style';
import { Children, Styles } from 'utils/types/react';

export interface ButtonProps {
  /** Button can render react components as label */
  children?: Children;
  /**  applies danger theme to button */
  danger?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  quaternary?: boolean;
  /** toggle disabled state */
  disabled?: boolean;
  loading?: boolean;
  onClick?: Function;
  onClickShowSpinner?: boolean;
  style?: Styles;
  forwardedRef?: React.Ref<HTMLButtonElement>;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  label?: string;
  link?: boolean;
  loaderLeft?: boolean;
  labelStyles?: Styles;
  outlined?: boolean;
  url?: string;
  hide?: boolean;
  setLoading?: Function;
  upperCase?: boolean;
  underline?: boolean;
  route?: string;
  type?: string;
  className?: string;
}

const defaultProps = {
  children: null,
  danger: false,
  forwardedRef: React.createRef(),
  iconLeft: null,
  iconRight: null,
  label: '',
  link: false,
  loaderLeft: false,
  outlined: false,
  url: '',
  hide: false,
  upperCase: false,
  underline: false,
  route: '',
};

function Button(props: ButtonProps) {
  const {
    children,
    iconLeft,
    iconRight,
    label,
    loaderLeft,
    forwardedRef,
    labelStyles,
    loading,
    onClick,
    style,
    setLoading,
    className,
    ...rest
  } = useButton<ButtonProps>(props);

  React.useImperativeHandle<any, { setLoading: Function }>(
    forwardedRef,
    () => ({
      setLoading,
    }),
  );

  function onClickHandler(...params) {
    const { url, route } = props;

    if (!loading && !props.disabled) {
      if (props.onClickShowSpinner) {
        setLoading(true);
      }

      if (url) {
        // TODO
      }

      if (route) {
        // Implement navigation handling
      }

      if (onClick) {
        onClick(...params);
      }
    }
  }

  const buttonProperties = {
    notLink: !props.link,
    ...rest,
  };

  const loader = <Loader $loading={loading} />;

  const loaderRight = loaderLeft === false;

  return (
    <StyledButton
      type="button"
      onClick={onClickHandler}
      style={style}
      className={className}
      {...buttonProperties}>
      <Content {...buttonProperties}>
        {loaderLeft && loader}
        {iconLeft}
        <Label {...buttonProperties} style={labelStyles}>
          {children || label}
        </Label>
        {iconRight}
        {loaderRight && loader}
      </Content>
    </StyledButton>
  );
}

Button.defaultProps = defaultProps;

export default Button;
